import { h } from 'preact';
import * as BaseComp from 'components/bolt/home/home.js';
import Store from 'store/store';
// import s from 'components/bolt/home/home.sss';

export default class Home extends BaseComp.default {

	scrollToNext(...args) {
		super.scrollToNext(...args);
		window.powT?.('scroll-cta');
		Store.emit('CUSTOM_EVENT', { action: 'scroll-click', category: '/microsite' });
	}

}
